import React from "react";
import "./ErrorPage.css";

function ErrorPage() {
    return <div className="errorPage">Ooops, page not found</div>;
}

export default ErrorPage;
